import { Component, EventEmitter, Output } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { FeedbackInput } from '@cpd-app/generated';

@Component({
  selector: 'cpd-feedback',
  templateUrl: './feedback.component.html',
  styleUrls: ['./feedback.component.scss']
})
export class FeedbackComponent {
  @Output() public closeDialog = new EventEmitter<void>();
  @Output() public feedback = new EventEmitter<FeedbackInput>();

  public recommendRating = 5;
  public comments = new FormControl('', [
    Validators.required,
    Validators.maxLength(4000)
  ]);

  constructor(private router: Router) {}

  public sendUserFeedback(): void {
    if (!this.recommendRating || this.comments.invalid) {
      return;
    }
    this.feedback.emit({
      routeUrl: this.router.url,
      recommendRating: this.recommendRating,
      comment: this.comments.value
    });
  }
}
